import React from "react";
type SectionHeadingProps = {
  eyebrow?: string;
  title: string;
  subtitle?: string;
  tone?: "light" | "dark";
};
export function SectionHeading({
  eyebrow,
  title,
  subtitle,
  tone = "light"
}: SectionHeadingProps) {
  const dark = tone === "dark";
  return <div className="mx-auto max-w-3xl text-center" data-id="element-62" data-mp="3f3gft4kndsbs">
      {eyebrow && <p className={`text-sm font-black uppercase tracking-wide ${dark ? "text-sun" : "text-brand"}`} data-id="element-63" data-mp="3k0oxl41vvuci">
          {eyebrow}
        </p>}
      <h2 className={`mt-2 text-balance text-[1.9rem] font-black leading-[1.12] sm:text-4xl lg:text-[2.75rem] ${dark ? "text-white" : "text-navy"}`} data-id="element-64" data-mp="gj6sh4dhx1fs">
        {title}
      </h2>
      {subtitle && <p className={`mt-4 text-lg font-semibold leading-relaxed ${dark ? "text-white/80" : "text-ink/75"}`} data-id="element-65" data-mp="6sc70282q5ve">
          {subtitle}
        </p>}
    </div>;
}